import { BaseViewModel } from '../../../models/base/base-view-model';
import { Injectable } from '@angular/core';

// Provided by Logged In Scope
@Injectable()
export class ProfileViewModel extends BaseViewModel {
  constructor() {
    super();
    this.init();
  }

  public init(): void {
    super.init();
  }
}
